import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import api from '../services/api';

export const fetchSettings = createAsyncThunk('settings/fetchSettings', async (_, { rejectWithValue }) => {
  try {
    const response = await api.get('/settings');
    return response.data.data;
  } catch (error) {
    return rejectWithValue(error.response?.data?.message || error.message || 'Failed to fetch settings');
  }
});

export const updateSetting = createAsyncThunk('settings/updateSetting', async (settingData, { rejectWithValue }) => {
  try {
    const response = await api.put('/settings', settingData);
    return response.data.data;
  } catch (error) {
    return rejectWithValue(error.response?.data?.message || error.message || 'Failed to update setting');
  }
});

const settingsSlice = createSlice({
  name: 'settings',
  initialState: {
    showAllDates: true,
    loading: false,
    updating: false,
    error: null
  },
  reducers: {
    setShowAllDates: (state, action) => {
      state.showAllDates = Boolean(action.payload);
    },
    clearSettingsError: (state) => {
      state.error = null;
    }
  },
  extraReducers: (builder) => {
    builder
      // Fetch Settings
      .addCase(fetchSettings.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchSettings.fulfilled, (state, action) => {
        state.loading = false;
        if (action.payload && action.payload.showAllDates !== undefined) {
          state.showAllDates = Boolean(action.payload.showAllDates);
        }
      })
      .addCase(fetchSettings.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      // Update Setting
      .addCase(updateSetting.pending, (state) => {
        state.updating = true;
        state.error = null;
      })
      .addCase(updateSetting.fulfilled, (state, action) => {
        state.updating = false;
        if (action.payload && action.payload.showAllDates !== undefined) {
          state.showAllDates = Boolean(action.payload.showAllDates);
        }
      })
      .addCase(updateSetting.rejected, (state, action) => {
        state.updating = false;
        state.error = action.payload;
      });
  }
});

export const { setShowAllDates, clearSettingsError } = settingsSlice.actions;
export default settingsSlice.reducer;
